import { HttpContext, HttpContextToken } from '@angular/common/http';

import { TotpLockScope } from '@app/core/services/totp-lock.service';

/**
 * Marca POR PETICIÓN del ámbito del freno del 2FA que la respuesta puede bloquear.
 *
 * La pone el ORIGEN: la verificación de la recuperación de contraseña y la del
 * login van al MISMO endpoint (`/api/users/auth/2fa/verify/`) y banca decide el
 * ámbito por el `mfa_token`, que el interceptor no lee. Sin marca ⇒ `principal`,
 * o sea el comportamiento de siempre para cualquier petición que no sepa de esto.
 *
 * `HttpContext` es client-side: no viaja al backend.
 */
export const TOTP_LOCK_SCOPE = new HttpContextToken<TotpLockScope>(() => 'principal');

/** `HttpContext` nuevo con el ámbito de recuperación. */
export function recoveryTotpLockContext(): HttpContext {
  return new HttpContext().set(TOTP_LOCK_SCOPE, 'recuperacion');
}
